import { useCallback, useMemo } from 'react';
import { useRxData } from 'rxdb-hooks';

import { getValueFromLocalStorage } from '../../utilities/utilityFunctions';
import { RxdbCollectionName } from '../rxdbCollectionName';
import type { AssetDetails, AssetDetailsCollection } from './assetDetails.types';

const useAssetDetails = () => {
  const getAssetDetailsquery = useCallback((collection: AssetDetailsCollection) => {
    return collection?.find({
      selector: { assetId: getValueFromLocalStorage('assetId') },
    });
  }, []);

  const { result } = useRxData<AssetDetails>(
    RxdbCollectionName.ASSET_DETAILS,
    getAssetDetailsquery,
  );

  const dynamicProperties = useMemo(() => {
    if (result.length)
      return result[0]?.assetDynamicProperty?.filter(
        val => val?.value !== null && val?.value?.length > 0,
      );
    return [];
  }, [result]);

  return { result: result[0], dynamicProperties };
};

export default useAssetDetails;
